import { createFileRoute } from '@tanstack/react-router';
import { getContractDetailsQuery } from '@/app/hooks/queries/useContracts';
import { useSuspenseQuery } from '@tanstack/react-query';
import EvaluationActivityLog from '@/app/components/features/evaluations/EvaluationActivityLog';
import { EvaluationTypeLabelsEnum } from '@/app/utils/constants';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/contracts/$contractId/_layout/(home)/activity',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { contractId } = Route.useParams();
  const { data: contract } = useSuspenseQuery(getContractDetailsQuery(contractId));

  return (
    <EvaluationActivityLog
      resourceName={contract.name}
      evaluationId={contractId}
      resourceType={EvaluationTypeLabelsEnum.CONTRACT}
      resourceCreatedAt={contract.createdAt}
    />
  );
}
